import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatTableDataSource } from '@angular/material';
import { ShowSSRSReportComponent } from '../ChildControls/show-ssrsreport/show-ssrsreport.component';
import { AutoMeasureReportConfig, MeasureNumDenumaretor } from '../models/IEncounterReport';
import { ILocationDetails } from '../models/ILocationDetails';
import { ONCCConfiguration, ONCCMasterMeasures } from '../models/IMasterAddedData';
import { IReportParameters } from '../models/IReportParameters';
import { IUserDetails } from '../models/IUsersDetails';
import { SchedularServiceService } from '../Services/Schedular/schedular-service.service';
import { UserManagementService } from '../Services/UserManagement/user-management.service';
import { SharedService } from '../Sharedservice/SharedService';
///import * as _ from 'lodash';
import { AutoMeasurePatientInfoComponent } from './auto-measure-patient-info/auto-measure-patient-info.component';
declare let $: any;
@Component({
  selector: 'app-oncc-mu',
  templateUrl: './oncc-mu.component.html',
  styleUrls: ['./oncc-mu.component.css']
})
export class OnccMUComponent {

  OnccMUform: FormGroup;
  columnsToDisplay: string[] = ['MeasureStatus', 'ProviderId', 'DControlled', 'DNonControlled', 'NControlled', 'NNonControlled', 'Numerator', 'Denominator', 'Result', 'TotPercentage'];
  //headercolumnsToDisplay = ['MeasureStatus', 'ProviderId', 'LocationId', 'DControlled', 'DNonControlled', 'NControlled', , 'NNonControlled', 'Numerator', 'Denominator', 'NonControlled', 'Controlled', 'Result', 'TotPercentage'];
  columnsToDisplay1: string[] = ['MeasureStatus', 'ProviderId', 'Numerator', 'Denominator', 'Result', 'TotPercentage'];
  columnsToDisplay2: string[] = ['PatientId', 'PatientName', 'ProviderName', 'LocationName'];
  onccConfigList: ONCCConfiguration[] = [];
  dataSource = new MatTableDataSource<AutoMeasureReportConfig>();
  dataSource1 = new MatTableDataSource<MeasureNumDenumaretor>();
  dataSource2 = new MatTableDataSource<AutoMeasureReportConfig>();
  DNonControlled: string = "";
  NNonControlled: string = "";
  savedDocurl: any = '';
  public lstYears = []
  public lstProviders: IUserDetails[] = [];
  public lstProvidersMaster: IUserDetails[] = [];
  public listMesureNames: ONCCMasterMeasures[];
  public lstworkListProviders: IUserDetails[];
  public lstLocations: ILocationDetails[] = [];
  public MesureNamesList: AutoMeasureReportConfig[];
  public MesuresList: MeasureNumDenumaretor[] = [];
  showStatus: boolean = false;

  constructor(private sharedService: SharedService,
    private schedulerservice: SchedularServiceService,
    private userService: UserManagementService, private formBuilder: FormBuilder, public dialog: MatDialog,) { this.savedDocurl = ''; }

  providerCode: string = null;

  async getLocations() {
    await this.schedulerservice.getLocations().subscribe(data => {
      this.lstLocations = data.sort((a, b) => a.locationName.localeCompare(b.locationName));
      this.lstLocations = this.lstLocations.filter(a => a.active == true);
      this.lstLocations.forEach((ele: any) => {
        ele.locationName = ele.locationAlias ? ele.locationAlias :
          ele.locationName
      })
    }, error => {
    })

  }
  getAllONCCConfigurations() {
    this.sharedService.getAllONCCConfiguration().subscribe(data => {
      this.onccConfigList = data;
    }, error => {
    });
  }


  getMeasureNames() {
    this.sharedService.getONCCMeasuresNameService(0, '').subscribe(data => {
      this.listMesureNames = data;
    });
  }

  selectedProviderList: IUserDetails[];
  selectedProviderIds: string;
  selectedLocIds: string;
  getCommonProviderLocations() {
    let arry: any = [];
    let selectLocarry = null;
    this.selectedProviderList = this.lstProviders.filter(item => item.selected == true)

    this.selectedList = this.selectedProviderList
    if (this.selectedList && this.selectedList.length > 0) {
      selectLocarry = this.selectedList.map(item => item.userLocations);
      selectLocarry.forEach(element => {
        arry.push(element.split(',').map(ele => ele.trim()));
      });

      this.cmnProvLocs = [];
      /* to find the Comman List of elements in array ex here Locationid */
      if (arry && arry.length > 0) {
        let obj = arry.reduce((a, b) => a.filter(c => b.includes(c)));
        this.cmnProvLocs = this.lstLocations.filter(item => obj.includes(item.locationId.toString()))
        this.cmnProvLocs.filter(item => item.selected = true)
      }

      if (this.cmnProvLocs.length > 0) {
        this.selectedLocIds = this.cmnProvLocs.map(x => x.locationId).join(',');
      } else {
        var defaultLocation = sessionStorage.getItem("LocationId");
        this.cmnProvLocs = this.lstLocations.filter(item => item.locationId == Number(defaultLocation));
        this.cmnProvLocs.filter(item => item.selected = true)
      }
    }

    this.OnccMUform.patchValue({
      LocationNames: this.cmnProvLocs.length > 0 ? this.cmnProvLocs.map(item => item.locationName).join(';') : ''
    })

    this.checkAllLocation(true)

  }
  cmnProvLocs: ILocationDetails[] = [];
  providerNames: string = '';
  locselected: string = '';
  selectedlocactions: string = '';
  selectedList: any = [];
  ngOnInit() {
    this.getMeasureNames()
    this.yearsdropdownlist();

    $(document).click(function (event) {
      if (event.target.id != "provideLocfocus") {
        var container = $("#provideLocfocushide");
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.hide();
        }
        if (event.target.id == "providerfocus") {
          $('#providerfocushide').show();
        }
      }
      if (event.target.id != "providerfocus") {
        var container = $("#providerfocushide");
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.hide();
        }
        if (event.target.id == "provideLocfocus") {
          $('#provideLocfocushide').show();
        }
      }
    });


    this.OnccMUform = this.formBuilder.group({
      ProviderName: [''],
      LocationNames: [''],
      MeasureName: [''],
      Year: [''],
      IsProvidersCheck: [''],
      IsLocationsCheck: ['']
    });

    this.getLocations();
    this.getAllUsersWithLocations();
    this.getAllONCCConfigurations();
  }

  focusOutFunctionprovideLoc(evn) {
    if (evn.keyCode === 9) {
      $('#provideLocfocushide').hide()
    } else if (evn.keyCode === 40 && evn.target.id == "provideLocfocus") {
      $('#provideLocoption0').focus();
    }
  }
  onLocationChanged(evn, location: ILocationDetails) {
    if (location.selected == null || location.selected == undefined)
      location.selected = true
    else
      location.selected = !location.selected;

    this.OnccMUform.patchValue({
      LocationNames: this.cmnProvLocs.length > 0 ? this.cmnProvLocs.filter(ele => ele.selected == true).map(item => item.locationName).join(';') : ''
    })
    this.selectedLocIds = this.cmnProvLocs.length > 0 ? this.cmnProvLocs.filter(ele => ele.selected == true).map(item => item.locationName).join(';') : ''


    let ischeckall = false;
    let selectedLocationList = this.cmnProvLocs.filter(item => item.selected == true)

    if (selectedLocationList.length > 0 && selectedLocationList != undefined) {

      ischeckall = (selectedLocationList.length === this.cmnProvLocs.length)
    }
    this.OnccMUform.patchValue({
      IsLocationsCheck: ischeckall
    });
    this.checkAllLocation('')
  }

  onSelectionChanged(event, type: string) {
    setTimeout(() => {
      if (event !== null && event !== undefined) {
        $(event.target).prev().trigger('focus');
      }
    }, 100);
  }
  public allUsers: IUserDetails[];
  splitCommasLocationsList: string[] = [];
  getAllUsersWithLocations() {
    this.userService.getAllUserswithLocations().subscribe(data => {
      this.allUsers = data.sort((a, b) => a.fullName.localeCompare(b.fullName));
      this.allUsers.forEach(element => {
        element.fullName = element.UserAliasName ? element.UserAliasName : element.fullName;
        this.splitCommasLocationsList = [];
        if (element.userLocations !== null) {
          var teststringss = element.userLocations.substring(0, element.userLocations.length - 1);
          this.splitCommasLocationsList.push(teststringss);
          element.userLocations = this.splitCommasLocationsList.toString();
        }
      });
      this.lstProvidersMaster = this.allUsers;

    },
      (err: any) => {
        console.log(err)

      });
  }
  yearsdropdownlist() {
    var years = [];
    var defaultYear = 2020;
    var maxDate = new Date().getFullYear();
    for (var i = defaultYear; i <= maxDate; i++) {
      years.push(i);
    }
    this.lstYears = years;
  }
  isvalidSEARCHdata() {
    try {
      if (this.OnccMUform.value.MeasureName || this.OnccMUform.value.Year || this.OnccMUform.value.ProviderName || this.OnccMUform.value.LocationNames) {
        if (this.OnccMUform.value.ProviderName == '' || this.OnccMUform.value.LocationNames == '' || this.OnccMUform.value.MeasureName == 'select' || this.OnccMUform.value.Year == '') {
          return false;
        }
      }
      else
        return false;
      return true;
    }
    catch (ex) {
      return false
    }
  }
  userIdenties: string;
  patCount: number = 0;
  getAutoMeasureCalculation() {
    this.selectedProviderIds = this.lstProviders.filter(i => i.selected == true).map(y => y.userId).join(',');
    this.userIdenties = this.lstProviders.filter(i => i.selected == true).map(y => y.userIdentity).join(',');
    this.selectedLocIds = this.cmnProvLocs.filter(i => i.selected == true).map(x => x.locationId).join(',');
    if (!this.isvalidSEARCHdata())
      return;
    //this.MeasureNamelectionchange(this.OnccMUform.value.MeasureName);

    this.sharedService.GetAutoMeasureCalculation(this.OnccMUform.value.MeasureName, this.OnccMUform.value.Year, this.selectedProviderIds, this.selectedLocIds).subscribe(
      data1 => {
        this.changeTableData();
        this.MesureNamesList = data1;
        this.dataSource.data = this.MesureNamesList;
        this.patCount = data1.length > 0 ? this.MesureNamesList[0].PatCount : 0;
        this.dataSource2.data = this.MesureNamesList;
      },
      (err: any) => {
        console.log(err)
      });
  }
  clearValues() {
    this.OnccMUform.patchValue({
      MeasureName: '',
      Year: '',
      LocationNames: '',
      ProviderName: '',
    });
    this.cmnProvLocs = []
    this.selectedProviderList = []
    this.selectedProviderIds = '';
    this.userIdenties = '';
    this.selectedLocIds = '';
    this.providerNames = '';
    this.lstProviders = this.lstProviders.filter(item => item.selected = false);
  }
  providerName(userId) {
    if (userId != undefined && userId != null && userId != "-") {
      let uName = this.lstProviders.filter(x => x.userId == userId);
      if (uName.length > 0)
        return uName[0].fullName;
    }
  }
  PatientStatusInfo: string = '';
  MeasureReport() {
    let reportParamters = new IReportParameters();
    reportParamters.reportUrl = 'NEMR/MeasureReport';
    reportParamters.parameters = {
      "MeasureName": this.OnccMUform.value.MeasureName,
      "Year": this.OnccMUform.value.Year,
      "ProviderIds": this.userIdenties,
      "LocationIds": this.selectedLocIds,
      "HeadLocId": Number(sessionStorage.getItem("LocationId")),
      "MeasurePatientInfo": this.PatientStatusInfo
    };
    const dialogRef = this.dialog.open(ShowSSRSReportComponent, {
      width: '850px',
      height: '100%',
      data: reportParamters
    });

    dialogRef.afterClosed().subscribe(result => {

    });

  }

  MeasureTranction() {
    let reportParamters = new IReportParameters();
    reportParamters.reportUrl = 'NEMR/AutoMeasureReport';
    reportParamters.parameters = {
      "MeasureName": this.OnccMUform.value.MeasureName,
      "Year": this.OnccMUform.value.Year,
      "ProviderIds": this.userIdenties,
      "LocationIds": this.selectedLocIds,
      "HeadLocId": Number(sessionStorage.getItem("LocationId")),
      "MeasurePatientInfo": this.PatientStatusInfo
    };
    const dialogRef = this.dialog.open(ShowSSRSReportComponent, {
      width: '850px',
      height: '100%',
      data: reportParamters
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }
  patId: number = 0;
  MeasurePatientInfo() {
    let reportParamters = new IReportParameters();
    reportParamters.reportUrl = 'NEMR/MeasurePatientInformationReport';
    reportParamters.parameters = {
      "MeasureName": this.OnccMUform.value.MeasureName,
      "Year": this.OnccMUform.value.Year,
      "ProviderIds": this.userIdenties,
      "LocationIds": this.linkedLocId,
      "Type": this.columnType,
      "PatId": this.patId,
      "HeadLocId": Number(sessionStorage.getItem("LocationId")),
      "MeasurePatientInfo": this.PatientStatusInfo,

    };
    const dialogRef = this.dialog.open(ShowSSRSReportComponent, {
      width: '850px',
      height: '100%',
      data: reportParamters
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  MeasureNamelectionchange(event) {
    const measurename = event.target.value;
    const MeasureId = this.listMesureNames.filter(i => i.measureName.trim() == measurename.trim())[0].measureId.toString();
    this.lstProviders = [];
    this.OnccMUform.patchValue({
      Year: '',
      LocationNames: '',
      ProviderName: '',
    });

    this.onccConfigList.filter(i => i.MeasureName == MeasureId).forEach(ele => {

      this.lstProvidersMaster.filter(i1 => ele.ProviderId.toLowerCase().trim() == i1.userId.toLowerCase().trim()).forEach(ele11 => {
        this.lstProviders.push(ele11);
      })

    });
    // this.clearValues();
    // this.OnccMUform.controls['MeasureName'].setValue(measurename);



  }
  counttype: string = '';

  NavGateURl() {
    switch (this.columnType) {

      case 'DControlled':
        this.counttype = '>>Denominator>>Controlled>>Patient Information'
        this.PatientStatusInfo = this.MeasureActionName1 + '' + this.counttype;
        break;
      case 'DNonControlled':
        this.counttype = '>>Denominator>>NonControlled>>Patient Information'
        this.PatientStatusInfo = this.MeasureActionName1 + '' + this.counttype;
        break;
      case 'NControlled':
        this.counttype = '>>Numerator>>Controlled>>Patient Information'
        this.PatientStatusInfo = this.MeasureActionName1 + '' + this.counttype;
        break;
      case 'NNonControlled':
        this.counttype = '>>Numerator>>NonControlled>>Patient Information'
        this.PatientStatusInfo = this.MeasureActionName1 + '' + this.counttype;
        break;
      case 'Numerator':
        this.counttype = '>>Numerator>>Patient Information'
        this.PatientStatusInfo = this.MeasureActionName1 + '' + this.counttype;
        break;
      case 'Denominator':
        this.counttype = '>>Denominator	>>Patient Information'
        this.PatientStatusInfo = this.MeasureActionName1 + '' + this.counttype;
        break;

    }


  }





  MeasureActionName: string;
  MeasureActionName1: string;
  isMasureName1: boolean = false;
  isMasureName2: boolean = false;
  isMasureName3: boolean = false;



  selected: string;
  selectedName: string;
  provider1: IUserDetails
  checkAllProviders(event) {
    this.lstProviders.filter(x => x.selected = event.target.checked);
    this.OnccMUform.patchValue({
      ProviderName: this.lstProviders.filter(x => x.selected == true).map(item => item.fullName).join(';')
    });
    this.getCommonProviderLocations();

  }

  onproviderselectionchange(providerRef, provider: IUserDetails) {
    this.cmnProvLocs = [];
    if (provider.selected == null || provider.selected == undefined)
      provider.selected = true
    else
      provider.selected = !provider.selected;

    this.OnccMUform.patchValue({
      ProviderName: this.lstProviders.filter(x => x.selected == true).map(item => item.fullName).join(';')
    });


    this.getCommonProviderLocations()

    this.checkAllprovider();
    var provlst = this.lstProviders.filter(x => x.selected == true).length
    if (provlst == 0) {
      this.OnccMUform.patchValue({
        LocationNames: '',
        IsLocationsCheck: false
      })
    }
  }

  providerSelectionChanged(providerRef) {


    this.selectedList = providerRef
      .selectedOptions.selected.map(item => item.value);
    this.lstProviders.filter(x => x.selected = false)
    this.selectedList.forEach(element => {
      this.lstProviders.filter(x => x.userId == element.userId).map(y => y.selected = true)
    });

    this.checkAllprovider()
  }
  checkAllprovider() {
    let ischeckall = false;
    if (this.selectedList.length > 0 && this.selectedList != undefined) {
      var selectProvlst = this.selectedList.filter(x => x.selected == true);
      ischeckall = (selectProvlst.length === this.lstProviders.length)
    }
    this.OnccMUform.patchValue({
      IsProvidersCheck: ischeckall
    });
  }

  checkAllLocation(event) {
    try {
      if (event.target)
        this.cmnProvLocs.filter(x => x.selected = event.target.checked);
      this.OnccMUform.patchValue({
        LocationNames: this.cmnProvLocs.filter(x => x.selected == true).map(item => item.locationName).join(';')

      });

      let ischeckall = false;
      let selectedLocationList = this.cmnProvLocs.filter(item => item.selected == true)

      if (selectedLocationList.length > 0 && selectedLocationList != undefined) {

        ischeckall = (selectedLocationList.length === this.cmnProvLocs.length)
      }
      this.OnccMUform.patchValue({
        IsLocationsCheck: (this.cmnProvLocs.length == 0) ? false : ischeckall
      });


    }


    catch (ex) {
    }
  }
  isNavigateMeasure: boolean = false;
  columnType: string;
  linkedLocId: string;
  linkedProviderId: string;
  onChangeMeasure(ele: any, type) {
    var measureName = this.OnccMUform.value.MeasureName;
    var year = this.OnccMUform.value.Year;
    this.patId = 0;
    this.columnType = type
    this.isMasureName1 = false;
    this.isMasureName2 = false;
    this.isMasureName3 = true;
    this.isNavigateMeasure = true;
    if (ele.LocationId != null && ele.LocationId != undefined && ele.LocationId != '' && ele.LocationId != '-') {
      this.linkedLocId = ele.LocationId;
    } else { this.linkedLocId = this.selectedLocIds; }

    if (ele.ProviderId != null && ele.ProviderId != undefined && ele.ProviderId != '' && ele.ProviderId != '-') {
      this.linkedProviderId = ele.ProviderId;
    } else { this.linkedProviderId = this.selectedProviderIds; }
    this.NavGateURl();
    this.sharedService.GetMeasureNumDenum(measureName, year, this.linkedProviderId, this.linkedLocId, type, this.patId).subscribe(
      data => {
        this.showStatus = false;
        this.MesuresList = data;
        this.dataSource1.data = this.MesuresList;
      },
      (err: any) => {
        console.log(err)
      });

  }
  navigatetoMeasure() {
    var measureName = this.OnccMUform.value.MeasureName;
    this.isMasureName1 = true;
    this.isMasureName2 = false;
    this.isMasureName3 = false;
    this.MeasureActionName1 = measureName;
    this.isNavigateMeasure = false;
    this.changeTableData()
  }

  changeTableData() {
    this.MeasureActionName = this.OnccMUform.value.MeasureName;
    if (this.MeasureActionName === "select") {
      this.isMasureName1 = false;
      this.isMasureName2 = false;
      this.isMasureName3 = false;
      this.MeasureActionName1 = ''
      this.isNavigateMeasure = false;
    }
    else if (this.MeasureActionName === "Electronic Prescribing") {
      this.isMasureName1 = true;
      this.isMasureName2 = false;
      this.isMasureName3 = false;
      this.MeasureActionName1 = this.MeasureActionName
      this.isNavigateMeasure = false;
    } else {
      this.isMasureName1 = false;
      this.isMasureName2 = true;
      this.isMasureName3 = false;
      this.MeasureActionName1 = this.MeasureActionName
      this.isNavigateMeasure = false;
    }
  }

  onChangePatientInfo(ele: any) {

    var measureName = this.OnccMUform.value.MeasureName;
    var year = this.OnccMUform.value.Year;
    if (ele.PatientId != '' && ele.PatientId != null)
      this.patId = ele.PatientId;
    //this.MeasureActionName1 = '';
    this.sharedService.GetMeasureNumDenum(measureName, year, this.linkedProviderId, this.linkedLocId, this.columnType, this.patId).subscribe(
      data => {
        this.MesuresList = data;
        this.PatientInfoPopup(measureName)
      },
      (err: any) => {
        console.log(err)
      });

  }

  PatientInfoPopup(mname: string) {
    const dialogRef = this.dialog.open(AutoMeasurePatientInfoComponent, {
      width: '750px',
      height: '450px',
      data: { measureName: mname, patMeasureList: this.MesuresList }
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }
}
